import React from 'react';
import { color, Text } from '@starrez/starryui9';
import { Highlighted } from '@starrez/starryui';
import styled from 'styled-components';
import { useServerGridContext } from '@starryui10/grids/ServerPagedGrid/ServerPageGridContext';

export const CustomLinkButton = (props: any) => {
    const { getCurrentHighlight } = useServerGridContext();

    const handleClick = () => {
        if (props.onClick) {
            props.onClick(props.data);
        }
    };

    const linkText = (
        <Text variant="normal.regular">
            <Highlighted Text={props.value.toString()} Highlight={getCurrentHighlight()} />
        </Text>
    );

    const linkButton = props.onClick ? <StyledLinkButton onClick={handleClick}>{linkText}</StyledLinkButton> : linkText;

    return linkButton;
};

export const StyledLinkButton = styled.button`
    color: ${color.Blue.B60};
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0;
    width: 100%;
    text-align: left;

    * {
        cursor: pointer;
    }

    &:hover {
        text-decoration: underline;
    }
`;
